import { Link } from "react-router-dom";

const PHONE = "0604026840";
const PHONE_DISPLAY = "06 04 02 68 40";
const WHATSAPP_URL = `https://wa.me/33604026840?text=Bonjour%2C%20j%27ai%20besoin%20d%27un%20serrurier%20en%20urgence`;
const TIKTOK_URL = "https://www.tiktok.com/@securycles.serrur?_t=8k12IzZz8Fs&_r=1";
const GMB_URL = "https://maps.app.goo.gl/kadTYV8afmpfdVSu8";

const footerServices = [
  "Ouverture de porte",
  "Serrure connectée",
  "Ouverture de voiture",
  "Blindage de porte",
  "Changement de serrure",
  "Serrurerie pro",
];

const footerZones = [
  { name: "Créteil", slug: "creteil" },
  { name: "Vitry-sur-Seine", slug: "vitry-sur-seine" },
  { name: "Saint-Maur-des-Fossés", slug: "saint-maur-des-fosses" },
  { name: "Champigny-sur-Marne", slug: "champigny-sur-marne" },
  { name: "Ivry-sur-Seine", slug: "ivry-sur-seine" },
  { name: "Maisons-Alfort", slug: "maisons-alfort" },
  { name: "Alfortville", slug: "alfortville" },
  { name: "Vincennes", slug: "vincennes" },
  { name: "Fontenay-sous-Bois", slug: "fontenay-sous-bois" },
  { name: "Villejuif", slug: "villejuif" },
  { name: "Nogent-sur-Marne", slug: "nogent-sur-marne" },
  { name: "Charenton-le-Pont", slug: "charenton-le-pont" },
];

const blogLinks = [
  { label: "Porte claquée : que faire ?", href: "/blog" },
  { label: "Serrure connectée : guide 2026", href: "/blog" },
  { label: "Choisir sa serrure 3 points", href: "/blog" },
  { label: "Urgence serrurier la nuit", href: "/blog" },
  { label: "Prix d'un serrurier à Créteil", href: "/blog" },
];

export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-white">
      {/* Stripe top */}
      <div
        className="h-3"
        style={{
          backgroundImage:
            "repeating-linear-gradient(90deg, #FFB100 0px, #FFB100 20px, #000000 20px, #000000 40px)",
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/8892c16dc9d95083db2eef95f931ffc6/474014a289bcb6e7215bd7741beb01c1.png"
              alt="Securycles Serrurier Créteil"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Serrurier d&apos;urgence à Créteil et dans tout le Val-de-Marne. Disponible 24h/24 et 7j/7 pour toute urgence serrurerie.
            </p>
            {/* Social */}
            <div className="flex items-center gap-3">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-[#FFB100]/10 rounded-full text-[#FFB100] hover:bg-[#FFB100] hover:text-black transition-colors cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line"></i>
              </a>
              <a
                href={TIKTOK_URL}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-[#FFB100]/10 rounded-full text-[#FFB100] hover:bg-[#FFB100] hover:text-black transition-colors cursor-pointer"
                aria-label="TikTok"
              >
                <i className="ri-tiktok-line"></i>
              </a>
              <a
                href={GMB_URL}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-[#FFB100]/10 rounded-full text-[#FFB100] hover:bg-[#FFB100] hover:text-black transition-colors cursor-pointer"
                aria-label="Google Maps"
              >
                <i className="ri-map-pin-line"></i>
              </a>
              <a
                href={`tel:${PHONE}`}
                className="w-9 h-9 flex items-center justify-center bg-[#FFB100]/10 rounded-full text-[#FFB100] hover:bg-[#FFB100] hover:text-black transition-colors cursor-pointer"
                aria-label="Téléphone"
              >
                <i className="ri-phone-line"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-black text-white text-sm uppercase tracking-wider mb-5">
              <a href="/#services" className="hover:text-[#FFB100] transition-colors">Services</a>
            </h4>
            <ul className="space-y-2.5">
              {footerServices.map((s) => (
                <li key={s}>
                  <a
                    href="/#services"
                    className="text-gray-400 text-sm hover:text-[#FFB100] transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-[#FFB100] text-xs"></i>
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Zones */}
          <div>
            <h4 className="font-black text-white text-sm uppercase tracking-wider mb-5">
              <a href="/#zones" className="hover:text-[#FFB100] transition-colors">Zones d&apos;intervention</a>
            </h4>
            <ul className="space-y-2.5">
              {footerZones.map((z) => (
                <li key={z.slug}>
                  <Link
                    to={`/serrurier/${z.slug}`}
                    className="text-gray-400 text-sm hover:text-[#FFB100] transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-map-pin-line text-[#FFB100] text-xs"></i>
                    {z.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Blog */}
          <div>
            <h4 className="font-black text-white text-sm uppercase tracking-wider mb-5">
              <Link to="/blog" className="hover:text-[#FFB100] transition-colors">Blog</Link>
            </h4>
            <ul className="space-y-2.5">
              {blogLinks.map((b) => (
                <li key={b.label}>
                  <Link
                    to={b.href}
                    className="text-gray-400 text-sm hover:text-[#FFB100] transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-article-line text-[#FFB100] text-xs"></i>
                    {b.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-black text-white text-sm uppercase tracking-wider mb-5">Légal</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/mentions-legales"
                  className="text-gray-400 text-sm hover:text-[#FFB100] transition-colors cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-arrow-right-s-line text-[#FFB100] text-xs"></i>
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link
                  to="/mentions-legales#cookies"
                  className="text-gray-400 text-sm hover:text-[#FFB100] transition-colors cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-arrow-right-s-line text-[#FFB100] text-xs"></i>
                  Politique de cookies
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Sub-footer */}
      <div className="border-t border-gray-800 bg-black py-4">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-gray-500">
          <p>© 2026 Securycles — Serrurier Créteil Val-de-Marne | Tous droits réservés</p>
          <a href={`tel:${PHONE}`} className="text-[#FFB100] font-bold hover:text-yellow-400 transition-colors cursor-pointer whitespace-nowrap">
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </footer>
  );
}
